import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ifHasErrors } from 'src/app/shared/helpers/helpers';

type FormValidation = {
    type: string;
    message: string;
};

@Component({
    selector: 'form-error',
    templateUrl: './form-error.component.html',
    standalone: true,
    imports: [CommonModule],
})
export class FormErrorComponent {
    @Input() form: any;
    @Input() controlName: string = '';
    @Input() validations: FormValidation[] = [];

    ifHasErrors = ifHasErrors;
}
